import React from 'react';
import DealerLayout from 'components/Layout/Dealer/DealerLayout';
import { DealersCustomerView } from 'pages/Shared/DealerCustomers';

export const DealersCustomerDealerView: React.FC = () => {
  return (
    <DealerLayout>
      <DealersCustomerView />
    </DealerLayout>
  );
};
